<app-card>
<div class ="container justify-content-start">
  <div  class ="row" style="text-align: center; ">
    <div class="col-md-12">
      <h4><b>Evaluation of results</b> </h4>
      <br/>
      <br/>
    </div>
  </div>  

  <div class="row">
    <div class="col-md-12">
    <br/>
    <br/>
    <p>Please note you will be evaluated for academic results based on your last funded application.</p>    
  </div>
  </div>

  <div class="row justify-content-center">

    <br/>
    <br/>
    <div class="col-md-4">
      <div class="d-grid gap-2">
        <button class="btn btn-outline-dark btn-md mb-3" type="button" (click)="close()">Cancel</button>
      </div>

    </div>
    <div class="col-md-4">
      <div class="d-grid">

        <button class="btn btn-primary btn-sm mb-6" type="button" (click)="moveToParentsPage()">Continue</button>
      </div>

    </div>

  </div>
</div>

</app-card>
